module.exports = __webpack_public_path__ + "static/img/privite-default-logo.f079cf7c.png";